export enum AppleWalletPassStyle {
    Generic = 0,
    BoardingPass = 1,
    Coupon = 2,
    EventTicket = 3,
    StoreCard = 4
}

export enum GoogleWalletPassStyle {
    Generic = 0,
    BoardingPass = 1,
    GiftCard = 2,
    EventTicket = 3,
    LoyaltyCard = 4,
    Offer = 5
}
